<template>
  <div class="pet-form__container">
    <FormTitle title="Введіть дані застрахованої тварини" />
    <div class="pet-form__fields">
      <div class="pet-form__field-row">
        <PetTypeSelector
          class="pet-form__field"
          label="Тип тварини *"
          :value="petType"
          :error-messages="getValidationErrors('petType', {
            required: 'Оберіть тип тварини',
          })"
          @change="onChangePetType"
          @blur="touchField('petType')"
        />
        <TextInput
          class="pet-form__field"
          placeholder="Порода *"
          :limit="30"
          v-model="petBreed"
          :error-messages="getValidationErrors('petBreed', {
            required: 'Введіть породу',
          })"
          @change="$emit('changePetBreed', $event)"
          @blur="touchField('petBreed')"
        />
      </div>
      <div class="pet-form__field-row">
        <PetSexSelector
          class="pet-form__field"
          label="Стать *"
          :value="petSex"
          :error-messages="getValidationErrors('petSex', {
            required: 'Оберіть стать',
          })"
          @change="onChangePetSex"
          @blur="touchField('petSex')"
        />
        <TextInput
          class="pet-form__field"
          placeholder="Кличка *"
          :limit="30"
          v-model="petAlias"
          :error-messages="getValidationErrors('petAlias', {
            required: 'Введіть кличку',
          })"
          @change="$emit('changePetAlias', $event)"
          @blur="touchField('petAlias')"
        />
      </div>
      <div class="pet-form__field-row">
        <DateInput
          class="pet-form__field"
          placeholder="Дата народження *"
          format="DD.MM.YYYY"
          type="input"
          :disabled-future-dates="true"
          v-model="petBirthDate"
          :error-messages="getValidationErrors('petBirthDate', {
            required: 'Введіть дату народження',
            validPetBirthDate: 'Невірна дата народження',
          })"
          @change="$emit('changePetBirthDate', $event)"
          @blur="touchField('petBirthDate')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { PetSexSelector, PetTypeSelector } from '@/features/selectors';
import { ValidateForm } from '@/shared/lib/form';
import { PetValidation } from '@/shared/lib/insurance';
import { DateInput, FormTitle, TextInput } from '@/shared/ui/form';

const { validPetBirthDate } = PetValidation();

export default {
  props: {
    initialPetType: {
      type: [String, Number, Object],
      default: null,
    },
    initialPetBreed: {
      type: String,
      default: null,
    },
    initialPetSex: {
      type: [String, Number, Object],
      default: null,
    },
    initialPetAlias: {
      type: String,
      default: null,
    },
    initialPetBirthDate: {
      type: [String, Date],
      default: null,
    },
  },
  data() {
    return {
      petType: this.normalizePetTypeValue(this.initialPetType),
      petBreed: this.initialPetBreed,
      petSex: this.normalizePetSexValue(this.initialPetSex),
      petAlias: this.initialPetAlias,
      petBirthDate: this.initialPetBirthDate,
    };
  },
  validations() {
    return {
      petType: { required },
      petBreed: { required },
      petSex: { required },
      petAlias: { required },
      petBirthDate: { required, validPetBirthDate },
    };
  },
  mixins: [ValidateForm],
  components: { FormTitle, TextInput, DateInput, PetTypeSelector, PetSexSelector },
  methods: {
    normalizePetTypeValue(value) {
      const raw = typeof value === 'object' ? value?.id : value;
      return raw != null ? String(raw) : null;
    },
    normalizePetSexValue(value) {
      const raw = typeof value === 'object' ? value?.id : value;
      return raw != null ? String(raw) : null;
    },
    onChangePetType(petType) {
      this.petType = this.normalizePetTypeValue(petType);
      this.$emit('changePetType', this.petType);
    },
    onChangePetSex(petSex) {
      this.petSex = this.normalizePetSexValue(petSex);
      this.$emit('changePetSex', this.petSex);
    },
  },
  watch: {
    initialPetType(newValue) {
      this.petType = this.normalizePetTypeValue(newValue);
    },
    initialPetBreed(newValue) {
      this.petBreed = newValue;
    },
    initialPetSex(newValue) {
      this.petSex = this.normalizePetSexValue(newValue);
    },
    initialPetAlias(newValue) {
      this.petAlias = newValue;
    },
    initialPetBirthDate(newValue) {
      this.petBirthDate = newValue;
    },
  },
};
</script>

<style scoped lang="scss">
.pet-form {
  &__container {
    margin-bottom: 24px;
  }
  &__fields {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  &__field-row {
    display: flex;
    gap: 24px;
    @media (max-width: 768px) {
      flex-direction: column;
      gap: 12px;
    }
  }
  &__field {
    flex: 1;
  }
}
</style>
